var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('h4',[_vm._v("Cleaning supply list")]),_vm._l((_vm.cleaning_supply_list),function(item,i){return _c('v-row',{key:i},[_c('v-col',{attrs:{"cols":"1"}},[_vm._v(" "+_vm._s(i+1)+" ")]),_c('v-col',{attrs:{"cols":"11"}},[_vm._v(" "+_vm._s(item.name)+" "),_c('br'),_c('small',[_vm._v("Price: "+_vm._s(item.price))])])],1)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }